import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '../codex/google-font-explorer/App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('google-font-explorer')
  if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  }
})
